let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jpCvr")).then(() => parcelRequire('71SlU'));